import React, { useEffect, useState } from "react";
import { Col, Container, Row, Spinner } from "reactstrap";

// redux
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchPackage } from "../../slices/apps/packageSlice";
import { fetchCustomers, fetchCustomer } from "../../slices/apps/customerSlice";
import { fetchEarningsSummary } from "../../slices/apps/agencySlices";

// hooks
import { useProfile } from "../../Components/Hooks/UserHooks";

// router
import { useLocation, useNavigate } from "react-router-dom";

// sayfalar, modallar vb.
import Checkout from "./Checkout";

const Payment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  const dispatch = useDispatch();
  const { userProfile } = useProfile();

  // State'ler
  const [pageLoading, setPageLoading] = useState(true);
  const [renewalCustomerData, setRenewalCustomerData] = useState(null);

  // Uzatma senaryosu kontrolü
  const isRenewalScenario = state?.isRenewal && state?.preselectedCustomerId;

  const fetchData = async () => {
    setPageLoading(true);
    try {
      await dispatch(fetchPackage(state.id)).unwrap();

      if (userProfile?.data?.Role != "SuperAdmin") {
        await dispatch(fetchEarningsSummary());
      }

      await dispatch(fetchCustomers()).unwrap();

      if (isRenewalScenario) {
        const customerResult = await dispatch(
          fetchCustomer(state.preselectedCustomerId),
        ).unwrap();
        setRenewalCustomerData(customerResult);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (!(state && state.id)) {
      navigate("/packages");
    } else {
      fetchData();
    }
  }, [state?.id]);

  const { packageLoading, customersLoading } = useSelector((state) => {
    return {
      packageLoading: state.package.packageLoading,
      customersLoading: state.customer.customersLoading,
    };
  }, shallowEqual);

  document.title = "Paket Satın Al | Global Yol Yardım";

  // Sayfa yüklenirken veya veriler çekilirken loading göster
  const showLoading =
    !(state && state.id) ||
    pageLoading ||
    packageLoading ||
    customersLoading ||
    (isRenewalScenario && !renewalCustomerData);

  if (showLoading) {
    return (
      <React.Fragment>
        <div className="position-absolute top-50 start-50 text-center">
          <Spinner animation="border" color="primary" />
          <p className="mt-3 text-muted">
            {isRenewalScenario
              ? "Müşteri ve paket bilgileri yükleniyor..."
              : "Paket bilgileri yükleniyor..."}
          </p>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="h-100">
                <Checkout
                  bulkSaleId={state.bulkSaleId}
                  preselectedCustomerId={state.preselectedCustomerId}
                  isRenewal={state.isRenewal}
                  carInfo={state.carInfo}
                  renewalCustomerData={renewalCustomerData}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Payment;
